import { useContext, useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import * as Yup from 'yup'

import { TextFieldComponent } from 'src/components/TextFieldComponent'
import { composePath, navigateToInstitute } from 'src/utils'
import { Autocomplete } from 'src/components/Autocomplete'
import { BoxButtons } from 'src/components/BoxButton'
import { ErrorText } from 'src/components/ErrorText'
import DataContext from 'src/contexts/DataContext'
import * as S from './styles'
import { Stepper } from 'src/components/Stepper'
import { emitNotificationEvent } from 'src/events'

import {
  useGetSchoolPeriods,
  useGetInstitutionTypes,
  useGetSchoolMetTypes,
  useGetStates,
  useGetCitiesByState,
  useGetSchoolsByCity,
} from 'src/services/backend'

const SearchPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  console.log(location.pathname)

  const toasts = {
    showGetStatesError: () =>
      emitNotificationEvent({
        id: 'getStatesError',
        type: 'error',
        title: 'Ops!',
        message: 'Ocorreu um erro ao carregar a lista de estados',
        isIndeterminate: true,
        textButton: 'Entendi',
      }),
    showGetSchoolsByCityError: () =>
      emitNotificationEvent({
        id: 'getSchoolsByCityError',
        type: 'error',
        title: 'Ops!',
        message: 'Ocorreu um erro ao carregar a lista de escolas',
        isIndeterminate: true,
        textButton: 'Entendi',
      }),
    showGetPeriodsError: () =>
      emitNotificationEvent({
        id: 'showGetPeriodsError',
        type: 'error',
        title: 'Ops!',
        message: 'Ocorreu um erro ao carregar a lista de períodos',
        isIndeterminate: true,
        textButton: 'Entendi',
      }),
    showGetInstitutionTypesError: () =>
      emitNotificationEvent({
        id: 'showGetInstitutionTypesError',
        type: 'error',
        title: 'Ops!',
        message: 'Ocorreu um erro ao carregar a lista de tipos de instituição',
        isIndeterminate: true,
        textButton: 'Entendi',
      }),
    showGetSchoolMetTypesError: () =>
      emitNotificationEvent({
        id: 'showGetSchoolMetTypesError',
        type: 'error',
        title: 'Ops!',
        message:
          'Ocorreu um erro ao carregar a lista de opções de como conheceu o instituto.',
        isIndeterminate: true,
        textButton: 'Entendi',
      }),
  }

  const validationScheema = Yup.object().shape({
    state: Yup.object()
      .shape({
        pk_id: Yup.number(),
        name: Yup.string(),
      })
      .nullable()
      .required('Estuda em qual estado? é obrigatório'),
    city: Yup.object()
      .shape({
        pk_id: Yup.number(),
        name: Yup.string(),
      })
      .nullable()
      .required('Estuda em qual cidade? é obrigatório'),
    school: Yup.object()
      .shape({
        pk_id: Yup.number(),
        name: Yup.string(),
      })
      .nullable()
      .when('state', {
        is: (value: any) => !!value,
        then: (schema) =>
          schema.required('Escola do(a) candidato(a) é obrigatória'),
      }),
    studing_period_type: Yup.object()
      .shape({
        pk_id: Yup.number(),
        name: Yup.string(),
      })
      .nullable()
      .required('Período em que estuda é obrigatório'),
    institution_type: Yup.object()
      .shape({
        pk_id: Yup.number(),
        name: Yup.string(),
      })
      .nullable()
      .required('Tipo de instituição é obrigatório'),
    school_met: Yup.object()
      .shape({
        pk_id: Yup.number(),
        name: Yup.string(),
      })
      .nullable()
      .required('Como conheceu a Germinare? é obrigatório'),
  })

  const defaultValues = {
    state: null,
    school: null,
    city: null,
    studing_period_type: null,
    institution_type: null,
    school_met: null,
  }

  const {
    control,
    formState: { errors, isValid, isDirty },
    watch,
    resetField,
    handleSubmit,
    reset,
    setValue,
  } = useForm({
    defaultValues,
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationScheema),
  })

  const schoolPeriods = useGetSchoolPeriods()
  const institutionTypes = useGetInstitutionTypes()
  const schoolMetTypes = useGetSchoolMetTypes()
  const states = useGetStates()
  const [currentState, setCurrentState] = useState()
  const [getCities, getCitiesResp] = useGetCitiesByState()
  const [getSchoolsByCity, getSchoolsByCityResp] = useGetSchoolsByCity()

  const { registration, setRegistration } = useContext(DataContext)
  const currentStep = registration.getStep(registration, 'search')

  const insertCourseName = () => {
    const course = location.pathname.split('/')[2]

    switch (course) {
      case 'vet-lins':
        return 'VET LINS'
      case 'vet-amparo':
        return 'VET AMPARO'
      case 'business':
        return 'BUSINESS'
      case 'vet':
        return 'VET'
      case 'tech':
        return 'TECH'
      default:
        return ''
    }
  }

  const setFormData = (formData: any) => {
    Object.keys(formData).forEach((field) => {
      //@ts-ignore
      setValue(field, formData[field])
    })

    reset(
      {},
      {
        keepErrors: true,
        keepDirty: false,
        keepDirtyValues: false,
        keepValues: true,
        keepDefaultValues: false,
        keepIsSubmitted: true,
        keepTouched: false,
        keepIsValid: true,
        keepSubmitCount: true,
      }
    ) // resetando alguns estados especificos do formulario
  }

  const submitForm = (data: any) => {
    if (isFormValid()) {
      if (isDirty) registration.setFormData(setRegistration, 'search', data)

      navigate(composePath('/responsaveis', `admissao/${registration.course}`))
    }
  }

  const isFormValid = () => isValid || !Object.keys(errors)?.length

  const handleStateChange = (field: any, value: any) => {
    field.onChange(value)
    resetField('school')
    resetField('city')

    if (value?.pk_id) {
      getCities(value.pk_id)
      setCurrentState(value.pk_id)
    }
  }

  const handleCityChange = (field: any, value: any) => {
    field.onChange(value)
    if (currentState && value?.pk_id)
      getSchoolsByCity(currentState, value.pk_id)
  }

  useEffect(() => {
    if (!registration.course)
      navigate(`/admissao/${localStorage.getItem('course')}`)

    if (!!currentStep?.formData) setFormData(currentStep.formData)
  }, [])

  useEffect(() => {
    if (currentStep?.formData?.state?.pk_id) {
      getCities(currentStep?.formData?.state?.pk_id)
      setCurrentState(currentStep?.formData?.state?.pk_id)

      if (currentStep?.formData?.city?.pk_id) {
        getSchoolsByCity(
          currentStep?.formData?.state?.pk_id,
          currentStep?.formData?.city?.pk_id
        )
      }
    }
  }, [currentStep?.formData])

  useEffect(() => {
    if (states?.error) toasts.showGetStatesError()
  }, [states?.error])

  useEffect(() => {
    if (schoolPeriods?.error) toasts.showGetPeriodsError()
  }, [schoolPeriods?.error])

  useEffect(() => {
    if (institutionTypes?.error) toasts.showGetInstitutionTypesError()
  }, [institutionTypes?.error])

  useEffect(() => {
    if (schoolMetTypes?.error) toasts.showGetSchoolMetTypesError()
  }, [schoolMetTypes?.error])

  useEffect(() => {
    if (getCitiesResp?.error) toasts.showGetSchoolsByCityError()
  }, [getCitiesResp?.error])

  return (
    <S.ContainerFlex onSubmit={handleSubmit(submitForm)}>
      <S.Content>
        <Stepper
          currentStepName={currentStep?.name}
          label={currentStep?.title}
          course={registration.course}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <S.Title>
              Responda à pesquisa sobre a escola em que o candidato(a) está
              matriculado(a) atualmente
            </S.Title>
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="state"
              control={control}
              render={({ field, fieldState }) => (
                <Autocomplete
                  {...field}
                  disablePortal
                  options={states?.data?.response || []}
                  getOptionLabel={(item) => item.name}
                  loading={states?.isLoading}
                  defaultValue={currentStep?.formData?.state}
                  onChange={(_, value) => {
                    handleStateChange(field, value)
                  }}
                  renderInput={(params) => (
                    <TextFieldComponent
                      {...params}
                      label="Estuda em qual estado?"
                      fullWidth
                      error={!!fieldState.error}
                    />
                  )}
                />
              )}
            />
            <ErrorText message={errors.state && errors.state.message} />
          </Grid>
          <Grid item xs={12} md={6}>
            {getCitiesResp?.data?.response ? (
              <>
                <Controller
                  name="city"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Autocomplete
                      {...field}
                      disabled={!watch('state')}
                      disablePortal
                      options={getCitiesResp?.data?.response}
                      getOptionLabel={(item) => item.name}
                      loading={getCitiesResp?.isLoading}
                      defaultValue={currentStep?.formData?.city}
                      onChange={(_, value) => {
                        handleCityChange(field, value)
                      }}
                      renderInput={(params) => (
                        <TextFieldComponent
                          {...params}
                          label="Estuda em qual cidade?"
                          fullWidth
                          error={!!fieldState.error}
                        />
                      )}
                    />
                  )}
                />
                <ErrorText message={errors.city && errors.city.message} />
              </>
            ) : (
              <TextFieldComponent
                label="Estuda em qual cidade?"
                fullWidth
                disabled
              />
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            {getSchoolsByCityResp?.data?.response ? (
              <>
                <Controller
                  name="school"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Autocomplete
                      {...field}
                      disablePortal
                      disabled={!watch('city')}
                      options={getSchoolsByCityResp?.data?.response}
                      getOptionLabel={(item) => item.name}
                      loading={getSchoolsByCityResp?.isLoading}
                      onChange={(_, value) => field.onChange(value)}
                      defaultValue={currentStep?.formData?.school}
                      renderInput={(params) => (
                        <TextFieldComponent
                          {...params}
                          label="Busque a escola do(a) candidato(a)"
                          fullWidth
                          error={!!fieldState.error}
                        />
                      )}
                    />
                  )}
                />
                <ErrorText message={errors.school && errors.school.message} />
              </>
            ) : (
              <TextFieldComponent
                label="Busque a escola do(a) candidato(a)"
                fullWidth
                disabled
              />
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="studing_period_type"
              control={control}
              render={({ field, fieldState }) => (
                <Autocomplete
                  {...field}
                  disablePortal
                  options={schoolPeriods?.data?.response}
                  getOptionLabel={(item) => item.name}
                  onChange={(_, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextFieldComponent
                      {...params}
                      label="Período em que estuda"
                      fullWidth
                      error={!!fieldState.error}
                    />
                  )}
                />
              )}
            />
            <ErrorText
              message={
                errors.studing_period_type && errors.studing_period_type.message
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="institution_type"
              control={control}
              render={({ field, fieldState }) => (
                <Autocomplete
                  {...field}
                  disablePortal
                  options={institutionTypes?.data?.response}
                  getOptionLabel={(item) => item.name}
                  onChange={(_, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextFieldComponent
                      {...params}
                      label="Tipo de instituição"
                      fullWidth
                      error={!!fieldState.error}
                    />
                  )}
                />
              )}
            />
            <ErrorText
              message={
                errors.institution_type && errors.institution_type.message
              }
            />
          </Grid>

          <Grid item xs={12}>
            <S.Title>
              {`Responda à pesquisa sobre o Instituto J&F - Germinare ${insertCourseName()}`}
            </S.Title>
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="school_met"
              control={control}
              render={({ field, fieldState }) => (
                <Autocomplete
                  {...field}
                  disablePortal
                  options={schoolMetTypes?.data?.response}
                  getOptionLabel={(item) => item.name}
                  onChange={(_, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextFieldComponent
                      {...params}
                      label="Como conheceu a Germinare?"
                      fullWidth
                      error={!!fieldState.error}
                    />
                  )}
                />
              )}
            />
            <ErrorText
              message={errors.school_met && errors.school_met.message}
            />
          </Grid>
        </Grid>
        <BoxButtons
          onClickPrevius={() =>
            navigate(
              composePath('/endereco', `admissao/${registration.course}`)
            )
          }
          isLoading={false}
          disableNextButton={false}
        />
      </S.Content>
    </S.ContainerFlex>
  )
}

export { SearchPage }
